// @ts-nocheck
/**
 * @module Adobe
 * @description
 */
import Script from 'next/script';

export const AdobeSnippet = () => (
    <>
      <Script
        strategy="afterInteractive"
        src="https://assets.adobedtm.com/fc19531c0bf6205e4c8c1a357c620866eec50643/satelliteLib-4b8641237ab881231ea9edcc135d0fdd111e2a40.js"
        onLoad={ () => {
          const { pathname, href } = window.location;
          let path = pathname.length > 1 ? pathname.substring( 1 ) : pathname;

          if ( path === '/' ) {
            path = 'home';
          }

          s_dtm.trackData( {
            pageName: `ftr:${ path }`,
            eVar22: 'visitor',
            eVar49: 'unverified service area'
          } );

          const loadDrift = () => {
            if( ! window?.drift ) {
              return setTimeout( loadDrift, 1000 );
            }

            drift.on('ready', ( api, payload ) => {

              drift.on( 'chatOpen', () => {
                s_dtm.trackData( {
                  'events': "event5",
                  'eVar5': href,
                  'eVar27': 'Chatbot'
                }, 'tl_o', 'chat_click' );
              } );

              drift.on( 'conversation:buttonClicked', ( data ) => {
                s_dtm.trackData( {
                  'events': 'event14',
                  'eVar14': data?.buttonBody
                }, 'tl_o', 'chat_reason' );
              } );
            } );
          }

          loadDrift();
        } }
      />
    </>
);

AdobeSnippet.displayName = 'AdobeSnippet';

export default AdobeSnippet;
